<section class="ShopSlider" id="LeftMenu_ShopSlider" *ngIf="sectionService.sections.length > 0">
	<div class="ShopSlider_Head uk-sticky">
		<div class="uk-slider">
			<div class="uk-slider-container">
				<div class="uk-slider-items uk-child-width-1-2@m uk-child-width-1-3@l">
					<div *ngFor="let category of sectionService.sections" class="ShopSliderSlide">
						<div class="ShopSliderSlide_Inner">
							<div class="ShopSliderSlide_Title">
								<span class="IconItem" [ngClass]="'IconItem--' + category.CODE">
									<img [src]="'/assets/img/icon/' + category.CODE + '.svg'" alt="" uk-svg>
								</span>
								<div class="ShopSliderSlide_Title_Name"
									[ngClass]="'ShopSliderSlide_Title_Name--' + category.CODE"
								>{{ category.NAME }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="ShopSlider_Content uk-slider uk-position-relative">
		<div class="uk-slider-container">
			<div class="uk-slider-items uk-child-width-1-2@m uk-child-width-1-3@l">
				<div *ngFor="let category of sectionService.sections" class="ShopSliderSlide">
				    <div class="ShopSliderSlide_Inner">
				        <ul class="ShopSliderSlide_List" uk-accordion="multiple: true; duration: 300;" *ngIf="category.SUBSECTIONS.length > 0">
				            <li *ngFor="let section of category.SUBSECTIONS">
								<a class="ShopSliderSlide_List_Title uk-accordion-title" [routerLink]="section.SUBSECTIONS.length > 0 ? null : ['/catalog/section/', section.CODE || section.ID]">
									<span class="ShopSliderSlide_List_Icon"
										[style.background-image]="section.PICTURE ? 'url(' + section.PICTURE.SRC + ')' : ''"
									></span>
									<span class="ShopSliderSlide_List_ItemName"
										[ngClass]="section.SUBSECTIONS.length > 0 ? 'ShopSliderSlide_List_ItemName--list' : 'ShopSliderSlide_List_ItemName--basket'"
									>{{ section.NAME }}</span>
								</a>

								<div class="ShopSliderSlide_List_Content uk-accordion-content uk-margin-remove-top">
									<ng-template [ngIf]="section.SUBSECTIONS.length > 0">
										<a *ngFor="let subSection of section.SUBSECTIONS"
											class="ShopSliderSlide_List_ItemName ShopSliderSlide_List_ItemName--sub" [routerLink]="['/catalog/section/', subSection.CODE || subSection.ID]"
										>{{ subSection.NAME }}</a>
									</ng-template>
								</div>
							</li>
				        </ul>
				    </div>
				</div>
			</div>
		</div>

		<a class="SliderArrow SliderArrow--left uk-position-center-left" href="#" uk-slider-item="previous">
			<span class="IconItem IconItem--arrowLeft">
				<img src="/assets/img/icon/arrow-left.svg" uk-svg>
			</span>
		</a>

		<a class="SliderArrow SliderArrow--right uk-position-center-right" href="#" uk-slider-item="next">
			<span class="IconItem IconItem--arrowRight">
				<img src="/assets/img/icon/arrow-right.svg" uk-svg>
			</span>
		</a>
	</div>
</section>
